import React from "react";
import { useMessageActions } from "../hooks/useMessageActions";
import { processCustomTags } from "../utils/textUtils";

interface SuggestedOptionsProps {
  options: Array<[string, string]>;
  parentNodeUuid: string;
  isReadOnly?: boolean;
  elementId: string;
}

const SuggestedOptions: React.FC<SuggestedOptionsProps> = ({
  options,
  parentNodeUuid,
  isReadOnly,
  elementId,
}) => {
  const { onOptionClick } = useMessageActions();
  // Filter out the "I am still experiencing this problem" option
  const filteredSuggestions = options.filter((option) => {
    const [optionText] = option;
    return optionText.includes("[Next]");
  });

  return (
    <div className="flex flex-col space-y-1 mt-2 bg-transparent w-fit">
      {filteredSuggestions.length > 0 && (
        <span className="text-xs sm:text-sm rounded-md bg-transparent text-gray-700 transition-colors duration-150 font-normal shadow-sm">
          Suggested:
        </span>
      )}
      {filteredSuggestions.map((suggestion, filteredIndex) => {
        const [suggestionText, nodeUuid] = suggestion;

        return (
          <button
            key={`suggestion-${filteredIndex}`}
            onClick={
              isReadOnly
                ? undefined
                : () => {
                    onOptionClick(
                      nodeUuid,
                      suggestionText.replace("[Next]", "").trim(),
                      parentNodeUuid,
                      elementId,
                      false // isDefinitionNode is false for suggested next topics
                    );
                  }
            }
            data-trust-trigger="suggested-next-topic-buttons"
            className={`group flex items-center text-left px-3 py-1.5 text-xs sm:text-sm rounded-md bg-transparent hover:bg-gray-200 text-gray-700 transition-colors duration-150 font-normal border border-transparent hover:border-gray-300 shadow-sm`}
            style={{
              maxWidth: "100%",
              cursor: isReadOnly ? "not-allowed" : "pointer",
              opacity: isReadOnly ? 0.6 : 1,
            }}
          >
            <span className="mr-2 inline-block text-base text-gray-400 group-hover:text-blue-400 transition-colors duration-150">
              {/* You can use a right arrow, chevron, or a sparkles/tip icon */}
              <svg width="18" height="18" fill="none" viewBox="0 0 18 18">
                <path
                  d="M7 5l3 4-3 4"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <span className="truncate">
              {processCustomTags(suggestionText.replace("[Next]", "").trim())}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default SuggestedOptions;
